<template>
    <div>
        <h3>{{slide.slide.title}}</h3>
        <div style="font-size: 125%;" v-html="sanitize(slide.slide.corpus)"></div>
        <ResourceGallery :resourceList="slide.slide.resources"></ResourceGallery>
        <hr>
        <div v-if="slideChangedSinceAttempt" class="question-review-change-notice">
            <b>NOTICE: Section has changed since this attempt!</b>
            <br>
        </div>
        <md-field>
            <label>Your Answer:</label>
            <md-textarea 
                required 
                v-model="answer" 
                name="answer" 
                :readonly="complete"
            ></md-textarea>
        </md-field>
        <div v-if="complete">
            <hr>
            <h2>Answer</h2>
            <hr>
            <span v-html="sanitize(slide.answer)"></span>
        </div>
        <CitationViewer :citations="slide.slide.citations" v-if="complete"/>
        <ResourceGallery :resourceList="slide.a_resources" v-if="complete"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" v-if="!complete" @click="submitAnswer()">
            Submit
        </md-button>
        <md-button class="md-raised md-primary" v-if="complete" @click="$emit('setDone', [slide.slide.order, true])">
            Continue
        </md-button>
    </div>
</template>

<script>

import ResourceGallery from './Gallery.vue'
import CitationViewer from './CitationViewer.vue'
import hasher from "object-hash"

export default {
    props: {
        slide: {
            type: Object
        },
        attemptRecord: {
            type: Object
        },
        complete: {
            type: Boolean
        },
        sanitize: {
            type: Function
        },
    },
    data: function(){
        return {
            answer: "",
            slideChangedSinceAttempt: false
        }
    },
    components: {
        ResourceGallery,
        CitationViewer,
    },
    methods: {
        submitAnswer: function(){
            if(this.answer.trim() == ""){
                this.$emit("notify", "Errors found, please correct and submit again!")
            }
            else{
                this.slide.complete = true
                var performance = {
                    performance: {
                        "Short Answer": this.answer,
                        "QHash": hasher(JSON.stringify(this.slide))
                    },
                }
                this.$emit('setDone', [this.slide.slide.order, false, performance])
            }
        },
        loadAttemptAnswer: function(){
            if(this.attemptRecord && this.attemptRecord.performance && Object.keys(this.attemptRecord.performance).length != 0){
                if(this.attemptRecord.performance["Short Answer"]){
                    this.answer = this.attemptRecord.performance["Short Answer"]
                }
                this.slideChangedSinceAttempt = hasher(JSON.stringify(this.slide)) != this.attemptRecord.performance["QHash"]
            }
        }
    },
    watch: {
        "attemptRecord": function() {
            this.loadAttemptAnswer()
        }
    },
    mounted: function(){
        this.$nextTick(function () {
            this.loadAttemptAnswer()
        })
    }
}
</script>

<style scoped>
.md-field{
    max-width: 80%;
    margin: auto;
    margin-bottom: 40px;
}
</style>